export default __webpack_public_path__ + "static/media/portfolio-3.ffe0b4b4.jpg";